import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import { setTicketBaseModal } from '../actions/generalActions'
import PropTypes from 'prop-types'

class TicketBaseListItem extends Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
    }

    handleTouchTap() {
        this.props.Callback(this.props.Ticket);
    }

    render() {
        const ticket = this.props.Ticket;
        const barcode = ticket.Barcode == null ? "" : ticket.Barcode;
        const validStart = ticket.ValidStart == null ? "" : ticket.ValidStart.split("T")[0];
        const validEnd = ticket.ValidEnd == null ? "" : ticket.ValidEnd.split("T")[0];
        const customerName = ticket.CustomerName == null ? "" : ticket.CustomerName;
        const description = ticket.Description == null ? "" : ticket.Description;
        return (
            <div className="listdiv">
                <button className="ticketListItem" onClick={evt => this.handleTouchTap(false)}>
                    <label className="listItemLabelTop">{description.trim()}</label>
                    <label className="listItemLabel">{barcode}</label>
                    <label className="listItemLabel">{customerName.trim()}</label>
                    <label className="listItemLabel">{validStart} - {validEnd}</label>
                    <Ink />
                </button>
            </div>
        )
    }
}

TicketBaseListItem.propTypes = { 
    Ticket: PropTypes.object.isRequired,
    Callback: PropTypes.func
}
function mapStateToProps() {
    return {

    }
}

export default connect(mapStateToProps, { setTicketBaseModal })(TicketBaseListItem)


// WEBPACK FOOTER //
// src/components/TicketBaseListItem.jsx